__turbopack_context__.v({
  "contentWrapper": "shaders-content-module__QK7sEW__contentWrapper",
  "infoSection": "shaders-content-module__QK7sEW__infoSection",
  "shaderCard": "shaders-content-module__QK7sEW__shaderCard",
  "shaderImage": "shaders-content-module__QK7sEW__shaderImage",
  "shaderInfo": "shaders-content-module__QK7sEW__shaderInfo",
  "shaderPreview": "shaders-content-module__QK7sEW__shaderPreview",
  "shadersGrid": "shaders-content-module__QK7sEW__shadersGrid",
});
